export default {
    data: () => ({
        translations: {
            createStore: {
                el: "Δημιουργία καταστήματος",
                en: "Create Store",
                it: "Crea negozio"
            },
            storeDetails: {
                el: "Στοιχεία καταστήματος",
                en: "Store Details",
                it: "Dettagli negozio"
            },
            storeName: {
                el: "Όνομα καταστήματος",
                en: "Store Name",
                it: "Nome del negozio"
            },
            storeCountry: {
                el: "Κατάστημα Χώρα",
                en: "Store Country",
                it: "Paese del negozio"
            },
            address: {
                el: "Διεύθυνση",
                en: "Address",
                it: "Indirizzo"
            },
            vatNumber: {
                el: "AΦΜ",
                en: "Vat Number",
                it: "Partita IVA"
            },
            email: {
                el: "Ε-mail",
                en: "Email",
                it: "E-mail"
            },
            primaryPhone: {
                el: "Τηλέφωνο Καταστήματος",
                en: "Primary Phone",
                it: "Telefono principale"
            },
        }
    })
};
